'use client';

import { HeroImage } from '../hero-image';

import { HeroSearchForm } from './form';

import type {
  PromoSettings,
  HeroSearch as Props,
} from '@/app/generated/graphql';

export const HeroSearch = ({
  heading,
  body,
  image,
  heroLink,
  heroCtaText,
  mobileImage,
  promo,
}: Pick<
  Props,
  'heading' | 'body' | 'image' | 'heroLink' | 'heroCtaText' | 'mobileImage'
> & {
  promo?: PromoSettings | null;
}) => {
  return (
    <div className="bg-gray-50">
      <div className="pb-c pt-d md:container md:py-c">
        <div className="grid relative sm:min-h-[420px] md:ml-0 md:min-h-[460px] md:grid-cols-12 lg:min-h-[480px]">
          <HeroImage
            image={image}
            mobileImage={mobileImage}
          />
          <div className="z-10 col-span-11 mb-[210px] flex rounded-l-rad-b md:col-span-11 md:col-start-2 md:mb-0 md:ml-c md:mt-0 md:min-h-[460px] md:items-center md:rounded-rad-b md:bg-none lg:min-h-[480px]">
            <HeroSearchForm
              heading={heading}
              body={body}
              heroLink={heroLink}
              heroCtaText={heroCtaText}
              promo={promo}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
